module.exports = __webpack_public_path__ + "static/ben-and-jerry-logo-a9cf6f85ae74bb146cb14693b5dc023b.png";